var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChengeNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5596 6.22743L13.4927 3.7074L16.0611 1.67945",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5501 11.0878C22.617 10.286 22.5231 9.4707 22.2737 8.68847C22.0243 7.90625 21.6243 7.17247 21.0966 6.52911C20.569 5.88576 19.924 5.34545 19.1985 4.9391C18.4731 4.53275 17.6814 4.26832 16.8688 4.16094L13.4927 3.7074",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44044 19.7725L10.5073 22.2925L7.93891 24.3204",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44987 14.912C1.38297 15.7138 1.47691 16.5292 1.72631 17.3114C1.97572 18.0936 2.37569 18.8274 2.90336 19.4708C3.43103 20.1141 4.07604 20.6544 4.80149 21.0608C5.52695 21.4671 6.31861 21.7316 7.1312 21.8389L10.5073 22.2925",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1284 2.75842H1.51081C1.17085 2.75842 0.895264 3.02882 0.895264 3.36237V11.8176C0.895264 12.1512 1.17085 12.4216 1.51081 12.4216H10.1284C10.4684 12.4216 10.744 12.1512 10.744 11.8176V3.36237C10.744 3.02882 10.4684 2.75842 10.1284 2.75842Z",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.661 22.9629H14.0455C13.8822 22.9629 13.7257 22.8993 13.6102 22.786C13.4948 22.6727 13.4299 22.5191 13.4299 22.359V21.755",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9699 13.2988H17.1233",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9699 22.9619H17.7388",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2786 19.338V17.5261",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4299 18.734V17.5261",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0476 22.9629H22.6632C22.8264 22.9629 22.983 22.8993 23.0984 22.786C23.2138 22.6727 23.2787 22.5191 23.2787 22.359V21.755",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0476 13.2988H22.6632C22.8264 13.2988 22.983 13.3625 23.0984 13.4757C23.2138 13.589 23.2787 13.7426 23.2787 13.9028V14.5067",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.661 13.2988H14.0455C13.8822 13.2988 13.7257 13.3625 13.6102 13.4757C13.4948 13.589 13.4299 13.7426 13.4299 13.9028V14.5067",
    stroke: "#5ED5A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChengeNetwork);
export default __webpack_public_path__ + "static/media/chenge-network.d76e9bd3ec5014a4f65caf8c28d32929.svg";
export { ForwardRef as ReactComponent };